<template>
  <div id="app">
    <router-view :key="this.$route.path"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  beforeCreate() {
    if(localStorage.getItem('lang') === null) {
      // 如果没有对应的值，设置默认值为 'defaultValue'
      localStorage.setItem('lang', 'zh-CN');
    }
  },
  created() {
   
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
  }
};
</script>
<style>
#app {
  width: 100%;
  height: auto;
  min-height: 100vh;
  position: relative;
}
nav {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue